import { BaseGender } from '../enums/base-gender.enum';

export const BaseGenderOptions = [
  { value: BaseGender.Frau, label: 'genderOptions.female' },
  { value: BaseGender.Herr, label: 'genderOptions.male' },
  { value: BaseGender.Diverse, label: 'genderOptions.other' },
];
